// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"LE-z","cltLink":"ME-z","shippingDisclaimer":"NE-z"};